import classNames from 'clsx';
import type React from 'react';

import styles from './Label.module.scss';

interface Props {
  id: string;
  hidden?: boolean;
  className?: string;
}
const Label: React.FC<React.PropsWithChildren<Props>> = ({ id, hidden, className, children }) =>
  children ? (
    <label htmlFor={id} className={classNames(styles.label, className)} aria-hidden={hidden}>
      {children}
    </label>
  ) : null;

Label.defaultProps = {
  hidden: false
};

export default Label;
